import {
  GrowthBook,
  GrowthBookProvider as GrowthBookProviderLib,
} from '@growthbook/growthbook-react'
import { useAppRootContext } from '@jusbrasil-web/shared-app-root-provider'
import { sendMetrics } from '@jusbrasil-web/shared-utils-events'
import { useMemo } from 'react'

import {
  GROWTHBOOK_ATTRIBUTES,
  GROWTHBOOK_EXPERIMENT_EVENT_NAME,
  GROWTHBOOK_INTERNAL_STATE,
} from '../constants'
import { AppPropsWithGrowthBook, GrowthBookProviderProps } from '../types'

const CLIENT_KEY = process.env.GROWTHBOOK_CLIENT_KEY || ''
const API_HOST = process.env.GROWTHBOOK_API_HOST
const ENABLE_DEV_MODE = process.env.NEXT_PUBLIC_GROWTHBOOK_DEV_MODE === 'true'

export function GrowthBookProvider(props: GrowthBookProviderProps) {
  const { children, pageProps } = props
  const { getPageProp } = useAppRootContext<AppPropsWithGrowthBook>()

  const features = getPageProp(GROWTHBOOK_INTERNAL_STATE) || pageProps[GROWTHBOOK_INTERNAL_STATE]
  const attributes = getPageProp(GROWTHBOOK_ATTRIBUTES) || pageProps[GROWTHBOOK_ATTRIBUTES]
  const growthbook = useMemo(() => {
    const { pid, device_id } = attributes || {}
    const gb = new GrowthBook({
      apiHost: API_HOST,
      clientKey: CLIENT_KEY,
      attributes,
      enableDevMode: ENABLE_DEV_MODE,
      trackingCallback: (experiment, result) =>
        sendMetrics(GROWTHBOOK_EXPERIMENT_EVENT_NAME, pid?.toString() ?? null, {
          experiment: experiment.name,
          alternative: result.name,
          device_id: device_id ?? null,
        }),
      features,
    })

    return pid || device_id ? gb.initSync({ payload: features || {}, streaming: false }) : gb
  }, [features, attributes])

  return <GrowthBookProviderLib growthbook={growthbook}>{children}</GrowthBookProviderLib>
}
